import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Skeleton, Stack, Tooltip, Typography } from '@mui/material'

import { COLOR_REALLOCATION_PRIMARY } from 'components/reports/Metrics/constants/AllocationStability'

interface Props {
  summaryPercentage: number
  loading?: boolean
}

export const ReAllocatedPercentStat = ({ summaryPercentage, loading }: Props) => (
  <Box sx={{ p: 3, flex: 1, textAlign: 'center' }}>
    <Stack direction='row' spacing={0.5} alignItems='center' justifyContent='center' mb={1.5}>
      <Typography variant='subtitle2' color={COLOR_REALLOCATION_PRIMARY}>
        % of Jobs Re-allocated
      </Typography>
      <Tooltip
        title='Percentage of all jobs in the selected period that were re-allocated to a different supplier.'
        placement='top'>
        <Box sx={{ display: 'flex', color: 'text.disabled', cursor: 'help' }}>
          <InfoOutlinedIcon sx={{ fontSize: 22, color: COLOR_REALLOCATION_PRIMARY }} />
        </Box>
      </Tooltip>
    </Stack>

    {loading ? (
      <Skeleton width={80} height={60} sx={{ mx: 'auto' }} />
    ) : (
      <Typography
        variant='h2'
        fontWeight={700}
        sx={{ color: COLOR_REALLOCATION_PRIMARY, lineHeight: 1, mb: 0.75 }}>
        {summaryPercentage.toFixed(1)}%
      </Typography>
    )}
  </Box>
)
